import { BrandIcon } from "@/components/BrandIcons";

export default function WhatsAppFloat() {
  return (
    <a
      data-testid="whatsapp-float-button"
      href="https://wa.me/60143856809"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with us on WhatsApp"
      className="fixed bottom-6 right-6 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-[0_12px_30px_-8px_rgba(37,211,102,0.6)] hover:scale-105 transition-transform duration-200"
    >
      <BrandIcon name="whatsapp" className="h-7 w-7" />
    </a>
  );
}
